module.exports = __webpack_public_path__ + "img/hearts.c82206a0.svg";